import React from 'react';
import { useTranslation } from 'react-i18next';
import AttendedCoursesContainer from "../AttendedEducationsContainer";
import Courses from "../../../Components/Customer/Educations/Courses";
import { ToggleCard } from "../../../Components/Card/ToggleCard";
const CourseContainer = () => {
    const { t } = useTranslation();
    
    const options = [
        {
            title: 'educations.courses',
            content: <Courses />
        },
        {
            title: 'educations.attendededucations',
            content: <AttendedCoursesContainer />
        }
    ];
    
    return (<ToggleCard title={'educations.courses'} options={options}/>
    );
};

export default CourseContainer;
